import styled from 'styled-components';
import { compose, space, width } from 'styled-system';
import { applyVariations, getPaletteColor } from '../utils/utils';
/**
 * @public
 */
export const Divider = /*#__PURE__*/styled.hr.attrs(({
  mx,
  ml,
  mr
}) => ({
  ml: mx ? null : ml,
  mr: mx ? null : mr
})).withConfig({
  displayName: "Divider",
  componentId: "sc-10weutl-0"
})(["border:0;border-bottom-style:solid;border-bottom-width:1px;border-color:", ";background-color:", ";", " ", ""], props => getPaletteColor(props.borderColor || props.color, 'base')(props), props => getPaletteColor(props.borderColor || props.color, 'base')(props), applyVariations('Divider'), props => compose(space, width)(props));
Divider.displayName = 'Divider';
Divider.defaultProps = {
  color: 'border',
  ml: 0,
  mr: 0
};